<script lang="ts" setup>
// ================================
// Composables
// ================================
const { t } = useI18n();
const route = useRoute();
const { baseline, baselineLoading } = storeToRefs(baselineStore());
const { areas } = storeToRefs(areaStore());
const { getBaseline } = baselineRepository();
const { stepperItems } = useBaselineConstants();

// ================================
// Data
// ================================
const breadcrumb = [
  {
    name: t('baseline.baselines'),
    url: '/references/baselines',
  },
];

// ================================
// Computed
// ================================
const activeStep = computed(() => {
  return stepperItems.value.findIndex((item) => item.routeName === route.name);
});

const title = computed(() => {
  const area = areas.value.find((area) => area.id === baseline.value?.area_id);
  return `${t('baseline.edit_baseline')}: ${area?.name ?? '...'}`;
});

onMounted(() => {
  getBaseline(Number(route.params.id));
});
</script>
<template>
  <ui-page :title="title" :breadcrumb="breadcrumb" :loading="baselineLoading">
    <div class="flex flex-col items-center gap-4 p-4 overflow-y-auto">
      <div class="max-w-[1000px] w-full pt-4 group group-hover:cursor-pointer">
        <u-stepper v-model="activeStep" :items="stepperItems" class="my-6" disabled />
        <nuxt-page />
      </div>
    </div>
  </ui-page>
</template>
